import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsOfService() {
  return <div className="min-h-screen bg-[#0f1724] text-[#f5f0e8] font-sans selection:bg-[#c9a84c] selection:text-[#0f1724] py-12 px-4 md:px-8" data-id="element-300">
      <div className="max-w-3xl mx-auto" data-id="element-301">
        <Link to="/" className="inline-flex items-center gap-2 text-[#c9a84c] hover:text-[#d4af37] transition-colors mb-8" data-id="element-302">
          <ArrowLeft className="w-4 h-4" data-id="element-303" />
          Back to Home
        </Link>

        <h1 className="font-serif text-3xl md:text-4xl text-white mb-8" data-id="element-304">
          Terms of Service
        </h1>

        <div className="space-y-6 text-[#f5f0e8]/80 leading-relaxed" data-id="element-305">
          <p data-id="element-306">Last updated: February 2025</p>

          <section className="space-y-3" data-id="element-307">
            <h2 className="text-xl text-white font-bold" data-id="element-308">
              1. Agreement to Terms
            </h2>
            <p data-id="element-309">
              By accessing our website and purchasing "The Shadow Rental Method"
              blueprint, you agree to be bound by these Terms of Service. If you
              do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="space-y-3" data-id="element-310">
            <h2 className="text-xl text-white font-bold" data-id="element-311">
              2. Intellectual Property Rights
            </h2>
            <p data-id="element-312">
              Unless otherwise indicated, the Site and the blueprint are our
              proprietary property and all source code, databases,
              functionality, software, website designs, audio, video, text,
              photographs, and graphics on the Site (collectively, the
              "Content") and the trademarks, service marks, and logos contained
              therein (the "Marks") are owned or controlled by us or licensed to
              us, and are protected by copyright and trademark laws.
            </p>
            <p data-id="element-313">
              The blueprint is for your personal use only. You may not
              distribute, sell, or share the content with others.
            </p>
          </section>

          <section className="space-y-3" data-id="element-314">
            <h2 className="text-xl text-white font-bold" data-id="element-315">
              3. User Representations
            </h2>
            <p data-id="element-316">
              By using the Site, you represent and warrant that: (1) you have
              the legal capacity and you agree to comply with these Terms of
              Service; (2) you are not a minor in the jurisdiction in which you
              reside; (3) you will not access the Site through automated or
              non-human means, whether through a bot, script or otherwise; (4)
              you will not use the Site for any illegal or unauthorized purpose;
              and (5) your use of the Site will not violate any applicable law
              or regulation.
            </p>
          </section>

          <section className="space-y-3" data-id="element-317">
            <h2 className="text-xl text-white font-bold" data-id="element-318">4. Refund Policy</h2>
            <p data-id="element-319">
              We offer a 30-day money-back guarantee. If you are not satisfied
              with the blueprint, you may request a full refund within 30 days
              of your purchase by contacting our support team.
            </p>
          </section>

          <section className="space-y-3" data-id="element-320">
            <h2 className="text-xl text-white font-bold" data-id="element-321">
              5. Limitation of Liability
            </h2>
            <p data-id="element-322">
              In no event will we or our directors, employees, or agents be
              liable to you or any third party for any direct, indirect,
              consequential, exemplary, incidental, special, or punitive
              damages, including lost profit, lost revenue, loss of data, or
              other damages arising from your use of the site or the blueprint.
            </p>
          </section>
        </div>
      </div>
    </div>;
}